import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppState } from "./Store";

interface UserComp {
  companyId: string;
  companyName: string;
  branchId: string;
  branchName: string;
  departmentId: string;
  departmentName: string;
  employmentDate: string;
  registerDate: string;
  updateDate: string;
}
interface User {
  auth: string;
  name: string;
  password: string;
  tel: string;
  email: string;
  status: string;
}

interface AuthState {
  token: string;
  isAuthenticated: boolean;
  id: string;
  user: User;
  userCompany: UserComp;
}

const initialState: AuthState = {
  token: "",
  isAuthenticated: false,
  id: "",
  user: {
    auth: "",
    name: "",
    password: "",
    tel: "",
    email: "",
    status: ""
  },
  userCompany: {
    companyId: "",
    companyName: "",
    branchId: "",
    branchName: "",
    departmentId: "",
    departmentName: "",
    employmentDate: "",
    registerDate: "",
    updateDate: ""
  }
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (
      state,
      action: PayloadAction<{
        token: string;
        id: string;
      }>
    ) => {
      const { token, id } = action.payload;
      state.isAuthenticated = true;
      state.token = token;
      state.id = id;
    },
    setUserDetail: (
      state,
      action: PayloadAction<{
        cmpn_id: string;
        cmpn_nm: string;
        brnc_id: string;
        brnc_nm: string;
        dprt_id: string;
        dprt_nm: string;
        mbr_id: string;
        mbr_pw: string;
        mbr_nm: string;
        mbr_tel: string;
        mbr_email: string;
        mbr_auth: string;
        mbr_stus: string;
        mbr_empl_dt: string;
        rgst_dt: string;
        updt_dt: string;
      }>
    ) => {
      const {
        cmpn_id,
        cmpn_nm,
        brnc_id,
        brnc_nm,
        dprt_id,
        dprt_nm,
        mbr_id,
        mbr_pw,
        mbr_nm,
        mbr_tel,
        mbr_email,
        mbr_auth,
        mbr_stus,
        mbr_empl_dt,
        rgst_dt,
        updt_dt
      } = action.payload;

      state.id = mbr_id;
      state.user = {
        auth: mbr_auth,
        name: mbr_nm,
        password: mbr_pw,
        tel: mbr_tel,
        email: mbr_email,
        status: mbr_stus
      };
      state.userCompany = {
        companyId: cmpn_id,
        companyName: cmpn_nm,
        branchId: brnc_id,
        branchName: brnc_nm,
        departmentId: dprt_id,
        departmentName: dprt_nm,
        employmentDate: mbr_empl_dt,
        registerDate: rgst_dt,
        updateDate: updt_dt
      };
    },
    clearAuth: state => {
      state.token = "";
      state.isAuthenticated = false;
      state.id = "";
    }
  }
});

export const { setAuth, setUserDetail, clearAuth } = authSlice.actions;

export const selectToken = (state: AppState) => state.auth.token;
export const selectIsAuth = (state: AppState) => state.auth.isAuthenticated;
export const selectId = (state: AppState) => state.auth.id;
export const selectUser = (state: AppState) => state.auth.user;
export const selectUserCompany = (state: AppState) => state.auth.userCompany;

export default authSlice.reducer;
